// Central place to edit Sliply's public business, contact & pricing details.
// Change values here and every public page (Pricing / Terms / Refunds / footer) updates.

export const SITE = {
  // Legal entity — EDIT to your registered name once available, e.g. "Sliply (Pty) Ltd".
  legalName: "Sliply",
  tradingAs: "Sliply",
  // Company / CIPC registration number (optional) — EDIT or leave "".
  regNumber: "",
  // VAT number (optional) — EDIT or leave "".
  vatNumber: "",

  // Contact details shown publicly.
  email: "info@sliply.co.za",
  // Phone (optional) — EDIT, e.g. "+27 11 123 4567", or leave "" to hide.
  phone: "",
  // Physical / postal address (optional) — EDIT, or leave "" to hide.
  address: "",

  domain: "sliply.co.za",
  jurisdiction: "South Africa",
  governingLaw: "the laws of the Republic of South Africa",
  // Shown on Terms & Refund pages.
  effectiveDate: "June 2026",
};

// ---- Pricing (DRAFT numbers — edit the prices & feature lists freely) ----
export const BILLING = {
  currency: "R", // ZAR symbol
  premiumMonthly: 49, // EDIT
  premiumYearly: 490, // EDIT (≈ 2 months free)
};

export const PLANS = [
  {
    id: "free",
    name: "Free",
    tagline: "Everything you need to stop losing slips.",
    price: 0,
    period: "forever",
    highlight: false,
    cta: "Sign up free",
    features: [
      { t: "Up to 30 receipt scans / month", on: true },
      { t: "AI merchant, item, date & total capture", on: true },
      { t: "Searchable spending history", on: true },
      { t: "Grocery price comparison", on: true },
      { t: "Earn Moolas, streaks & badges", on: true },
      { t: "Warranties & Claim Packs", on: false },
      { t: "Trips & holiday budgets", on: false },
      { t: "Ask AI about your spending", on: false },
      { t: "PDF reports & VAT reclaim", on: false },
    ],
  },
  {
    id: "premium",
    name: "Premium",
    tagline: "The full spending brain for homes & businesses.",
    price: null, // uses BILLING.premiumMonthly / premiumYearly
    period: "month",
    highlight: true,
    cta: "Go Premium",
    features: [
      { t: "Unlimited receipt scans", on: true },
      { t: "Everything in Free", on: true },
      { t: "Warranties & Claim Packs", on: true },
      { t: "Trips & holiday budgets", on: true },
      { t: "Ask AI about your spending", on: true },
      { t: "PDF reports & VAT reclaim (business)", on: true },
      { t: "Email-forwarding receipt capture", on: true },
      { t: "Multi-currency, auto-detected", on: true },
      { t: "Priority support", on: true },
    ],
  },
];
